/**
 * @fileoverview Type-safe assertion function for unreachable code paths. From
 *               https://stackoverflow.com/a/39419171/1119954
 *
 * This function should be used in switch statements or if-else chains
 * where TypeScript can prove that a code path should never be reached.
 * If the code path is reached at runtime, it throws an error.
 *
 * @param x - The value that should never be reached (typed as `never`)
 * @throws {Error} Always throws an error since this code should never be reached
 *
 * @example
 * ```typescript
 * switch (status) {
 *   case 'loading':
 *     return <Loading />
 *   case 'success':
 *     return <Success />
 *   case 'error':
 *     return <Error />
 *   default:
 *     return assertUnreachable(status) // TypeScript ensures this is exhaustive
 * }
 * ```
 */
export function assertUnreachable(x: never): never {
  throw new Error(`Unexpected value: ${JSON.stringify(x)}`)
}
